import { useMemo } from 'react';

import { apiClient, initializeApiClient } from '@/api/api.client';

export const useApi = () => {

    // Initialize the API client with the current URL
    // This ensures the singleton instance is created/updated when apiUrl changes
    initializeApiClient();

    // Return the memoized API client object
    // The functions reference the singleton instance via getAxiosInstance(),
    // so the object itself doesn't need to change - functions always use current instance
    return useMemo(() => apiClient, []); // Empty deps - object structure never changes
};
